import { render, staticRenderFns } from "./PlantOverviewNew.vue?vue&type=template&id=2d1c5010&scoped=true"
import script from "./PlantOverviewNew.vue?vue&type=script&lang=js"
export * from "./PlantOverviewNew.vue?vue&type=script&lang=js"
import style0 from "./PlantOverviewNew.vue?vue&type=style&index=0&id=2d1c5010&prod&lang=css"
import style1 from "./PlantOverviewNew.vue?vue&type=style&index=1&id=2d1c5010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c5010",
  null
  
)

export default component.exports